import { useState } from "react";
import ar_white from "../../../assets/images/Introduction/ar_white.svg";
import home_white from "../../../assets/images/Introduction/home_white.svg";
import sol1 from "../../../assets/images/Solution/sol1.webp";
import bggp from "../../../assets/images/Solution/bggp.webp";

export default function SolutionBanner() {
  const [isOpen, setIsOpen] = useState(false);

  const smoothScroll = (id) => {
    if (id === "top") {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      const element = document.getElementById(id);

      if (element) {
        const headerElement = document.querySelector(".z-50.fixed");
        const headerHeight = headerElement?.offsetHeight || 0;

        const elementPosition = element.offsetTop - headerHeight;
        window.scrollTo({
          top: elementPosition,
          behavior: "smooth",
        });
      }
    }
    setIsOpen(false);
  };
  return (
    <div
      className="w-full bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url(${window.innerWidth < 768 ? bggp : bggp})`,
      }}
    >
      <div className="w-full container mx-auto px-[20px] py-[20px] grid grid-cols-1 lg:grid-cols-2 gap-4 items-center">
        <div className="w-full flex flex-col gap-3">
          <div className="w-full flex items-center gap-2 text-white">
            <img src={home_white} alt="bg" />
            <img src={ar_white} alt="nnhh" />
            <p className="text-[16px] font-normal">Giải pháp</p>
          </div>
          <div>
            <p className="text-[28px] md:text-[32px] md:text-center lg:text-start text-white font-semibold lg:w-[620px]">
              HỆ SINH THÁI TOÀN DIỆN CHO TRUNG TÂM GIÁO DỤC
            </p>
          </div>
          <div>
            <p className="text-[16px] text-white font-normal md:text-center lg:text-start lg:w-[80%]">
              Tối ưu quản lý, nâng cao trải nghiệm học tập và thúc đẩy sự phát
              triển bền vững cho trung tâm của bạn
            </p>
          </div>
          <div className="flex items-center justify-center md:justify-center lg:justify-start">
            <button
              className="flex items-center justify-center hover:bg-[#E6ECFA]  lg:w-[323px] md:w-[200px] h-[54px] w-full text-black bg-white border border-solid border-[#C7C7C7] rounded-[30px]"
              onClick={() => {
                smoothScroll("outl");
                setIsOpen(false);
              }}
            >
              <p className="font-normal">Tìm hiểu thêm</p>
            </button>
          </div>
        </div>
        <div className="w-full flex items-center justify-center">
          <img src={sol1} alt="bl2" className=" w-full h-auto object-cover" />
        </div>
      </div>
    </div>
  );
}
